{
    "locale": "hu-HU",
    "General": {
        "OrText": "Vagy",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Ugrás a My Hubertihez"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Új fiók létrehozása",
        "ButtonText_SignInToYourAccount": "Bejelentkezés a fiókba",
        "ButtonText_StartInterviewWithoutSigningUp": "Interjú indítása regisztráció nélkül",
        "ButtonText_StartInterviewWithoutSigningIn": "Interjú indítása bejelentkezés nélkül",
        "Navlink_Dashboard": "Vezérlőpult",
        "Navlink_MyInterviews": "Interjúim",
        "Navlink_LearnWithHubert": "Tanulj Huberttel",
        "Navlink_HelpCenter": "Súgóközpont",
        "MyProfile": "Profilom",
        "LogOut": "Kijelentkezés"
    },
    "Login": {
        "MainTitle": "Nézd meg a Hubert-interjúd eredményeit",
        "Subtitle": "Jelentkezz be, hogy lásd az eredményeket, kapj visszajelzést, olvass tanácsokat és még sok mást.",
        "LoginTitle": "Jelentkezz be Hubert-fiókodba",
        "Label_Email": "E-mail",
        "Label_Password": "Jelszó",
        "ButtonText_SignIn": "Bejelentkezés",
        "ButtonText_ForgotPassword": "Elfelejtett jelszó?",
        "ButtonText_ContinueWithGoogle": "Folytatás Google-lel",
        "OrSeparator": "Vagy",
        "Error_Email_Required": "Az e-mail megadása kötelező.",
        "Error_Email_Invalid": "Adj meg érvényes e-mail-címet.",
        "Error_Password_Required": "A jelszó megadása kötelező.",
        "Error_Use_Same_Email_As_Interview": "Kérjük, ugyanazt az e-mail-címet használd, mint az interjúban."
    },
    "Registration": {
        "MainTitle": "Nézd meg a Hubert-interjúd eredményeit",
        "Subtitle": "Regisztrálj, hogy lásd az eredményeket, kapj visszajelzést, olvass tanácsokat és még sok mást.",
        "RegistrationTitle": "Hubert-fiók létrehozása",
        "BenefitsBox_Title": "Lehetőségeid",
        "BenefitsBox_Point1": "Hozzáférés az interjú-előzményekhez",
        "BenefitsBox_Point2": "Visszajelzés az interjúidról",
        "BenefitsBox_Point3": "Korábbi válaszok újrafelhasználása",
        "BenefitsBox_Point4": "Interjútanácsok",
        "BenefitsBox_Point5": "Karrier-útmutatók olvasása",
        "BenefitsBox_Point6": "És még sok más",
        "Label_FirstName": "Keresztnév",
        "Label_LastName": "Vezetéknév",
        "Label_Email": "E-mail",
        "Label_Password": "Jelszó",
        "Label_PhoneNumber": "Telefonszám",
        "Label_TermsOfService": "Elfogadom a",
        "Label_TermsOfServiceLink": "Adatvédelmi irányelveket és a Felhasználási feltételeket",
        "Placeholder_CountryCode": "Országkód kiválasztása",
        "Placeholder_PhoneNumber": "Pl. 06201234567",
        "HelpText_Password": "A jelszónak legalább 6 karakter hosszúnak kell lennie.",
        "ButtonText_SignUp": "Regisztráció",
        "ButtonText_SignUpWithGoogle": "Regisztráció Google-lel",
        "OrSeparator": "Vagy",
        "Error_FirstName_Required": "A keresztnév megadása kötelező.",
        "Error_LastName_Required": "A vezetéknév megadása kötelező.",
        "Error_Email_Required": "Az e-mail megadása kötelező.",
        "Error_Email_Invalid": "Adj meg érvényes e-mail-címet.",
        "Error_Email_Exists": "Ez az e-mail már foglalt.",
        "Error_Password_Required": "A jelszó megadása kötelező.",
        "Error_Password_6_Characters": "A jelszónak legalább 6 karakter hosszúnak kell lennie.",
        "Error_PhoneNumber_Required": "A telefonszám megadása kötelező.",
        "Error_PhoneNumber_Invalid": "Érvénytelen telefonszám.",
        "Error_PrivacyPolicyCheck_Required": "El kell fogadni az Adatvédelmi irányelveket és a Felhasználási feltételeket."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "Az interjú megkezdéséhez el kell fogadnod a Hubert használati feltételeit. Egyszerűen pipáld ki a mezőt a folytatáshoz.",
        "Subtitle_AfterInterviewCompleted": "Regisztrálj, hogy lásd az eredményeket, kapj visszajelzést, olvass tanácsokat és még sok mást.",
        "PrivacyPolicyText": "A Regisztráció gomb megnyomásával elfogadod a",
        "PrivacyPolicyLink": "Adatvédelmi irányelveket és a Felhasználási feltételeket",
        "ButtonText_SignUp": "Regisztráció és irány az interjú",
        "ButtonText_SignUpNormal": "Regisztráció",
        "ButtonText_SignInInstead": "Kattints ide a bejelentkezéshez"
    },
    "LoginInviteEmail": {
        "Subtitle": "Jelentkezz be, hogy lásd az eredményeket, kapj visszajelzést, olvass tanácsokat és még sok mást."
    },
    "AppMessages": {
        "internal-server-error": "Váratlan hiba történt.",
        "invalid-credentials": "Érvénytelen bejelentkezési adatok. Próbáld újra.",
        "user-not-found": "Érvénytelen bejelentkezési adatok. Próbáld újra.",
        "account-not-found": "Érvénytelen fiók. Próbáld újra.",
        "verify-email-title": "E-mail ellenőrzése",
        "verify-email-subtitle": "Kérjük, ellenőrizd az e-mailjeidet a fiók megerősítéséhez.",
        "email-not-verified-title": "Az e-mail nincs megerősítve",
        "email-not-verified-subtitle": "Kérjük, ellenőrizd az e-mailjeidet a fiók megerősítéséhez.",
        "verifying-email-title": "E-mail ellenőrzése folyamatban",
        "verifying-email-subtitle": "Kérjük, várj...",
        "sign-in-title": "Bejelentkezés",
        "sign-in-subtitle": "Kérjük, várj...",
        "server-error": "Valami hiba történt.",
        "hubert-user-exists": "A fiók már létezik.",
        "account-exists": "A fiók már létezik.",
        "email-verified": "Az e-mail címed megerősítve.",
        "email-is-taken": "Ez az e-mail már foglalt.",
        "re-enter-password": "Jelentkezz be a jelszavaddal",
        "password-reset": "A jelszavad megváltozott.",
        "re-enter-new-password": "Jelentkezz be az új jelszavaddal",
        "invalid-invitation": "Érvénytelen meghívó.",
        "invalid-code": "Érvénytelen ellenőrző kód.",
        "email-already-verified": "Az e-mail már megerősítve.",
        "email-mismatch-title": "E-mail-eltérés",
        "email-mismatch-subtitle": "Kérjük, használd ugyanazt az e-mail címet, amellyel jelentkeztél."
    },
    "TransitionPage": {
        "loading-title": "Betöltés...",
        "loading-subtitle": "Adatok előkészítése...",
        "logout-title": "Betöltés...",
        "logout-subtitle": "Kijelentkezés folyamatban..."
    },
    "ImpersonationPage": {
        "loading-title": "Betöltés...",
        "loading-subtitle": "Adatok előkészítése..."
    },
    "ProcessInvitation": {
        "loading-title": "Betöltés...",
        "loading-subtitle": "Kérjük, várj, az interjúdat töltjük be.",
        "InvitationNotFound": "Nem találjuk az interjúdat.",
        "InvitationExpired": "Ez a link lejárt.",
        "InvitationExpired_Description1": "Nyisd meg az interjút innen.",
        "InvitationExpired_Description2": "vagy vedd fel a kapcsolatot a toborzóval.",
        "InvitationInvalid": "A meghívó linkje érvénytelen.",
        "InterviewCompleted": "Ez az interjú már befejeződött."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Interjúim",
            "TableHead_Employer": "Munkaadó",
            "TableHead_Job": "Pozíció",
            "TableHead_Status": "Állapot",
            "TableHead_ApplicationDate": "Jelentkezés dátuma",
            "TableBody_StartInterview": "Az interjú nincs befejezve. Kattints ide az indításhoz vagy folytatáshoz.",
            "TableBody_NotScored": "Az interjú befejeződött, az eredmények hamarosan elérhetők.",
            "TableBody_Details": "Kattints ide az interjú eredményeinek megtekintéséhez.",
            "ApplicationDate_Invited": "Meghívva",
            "ApplicationDate_MinuteAgo": "perce",
            "ApplicationDate_MinutesAgo": "perccel ezelőtt",
            "ApplicationDate_HourAgo": "órája",
            "ApplicationDate_HoursAgo": "órával ezelőtt",
            "ApplicationDate_DayAgo": "napja",
            "ApplicationDate_DaysAgo": "napja",
            "ButtonText_SeeAllInterviews": "Összes interjú megtekintése",
            "ButtonText_Details": "Részletek",
            "ButtonText_StartInterview": "Ugrás az interjúra",
            "ButtonText_NotScored": "Eredmények függőben",
            "NoInterviews_Message": "Nincsenek korábbi vagy közelgő interjúk."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Jelenleg nincsenek állásajánlatok. Nézz vissza később."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Karrierem",
            "Subtitle": "Válaszd ki az interjút az értékelés és kilátások megtekintéséhez.",
            "MostRecentInterview": "Legutóbbi interjú",
            "ToDo": "Tennivalók",
            "NoOngoingInterviews_Title": "Nincs új interjúmeghívód.",
            "NoOngoingInterviews_Subtitle": "Az új Hubert-interjúk itt jelennek meg, amint a toborzók ütemezik őket.",
            "NoRecentInterviews_Title": "Nincs korábbi interjúfeljegyzés.",
            "NoRecentInterviews_Subtitle": "Amint meghívnak egy interjúra, itt fog megjelenni.",
            "ButtonText_StartInterview": "Ugrás az interjúra",
            "ButtonText_NotScored": "Eredmények függőben",
            "ButtonText_Details": "Részletek"
        },
        "LearnWithHubert": {
            "Title": "Tanulj Huberttel",
            "Subtitle": "Kapj tanácsokat az interjúkban és a munkahelyeden való fejlődéshez.",
            "PickedForMe": "Legújabb cikkek",
            "ButtonText_SeeAllArticles": "Összes cikk megtekintése"
        },
        "HubertTip": {
            "Title": "Hubert tipp",
            "Subtitle": "Gyorsabb interjúzás",
            "Description": "Hasonló pozícióra pályázol, amelyhez már korábban volt Hubert-interjúd? Újra felhasználhatod korábbi válaszaidat, és időt spórolhatsz.",
            "ButtonText_ReadMoreTips": "További tippek"
        },
        "NewCandidateModalPopup": {
            "Title": "Minden készen áll!",
            "DescriptionLine1": "A fiókod most már használatra kész.",
            "DescriptionLine2": "Kezeld interjúidat és profilodat. Nézd meg az eredményeidet, szerezz visszajelzést, és tanulj meg többet az interjúkról.",
            "ButtonText_LetsGo": "Kezdjük"
        },
        "InterviewCompletedModal": {
            "Title": "Szép munka!",
            "Subtitle": "Befejezted az interjút.",
            "Description": "A toborzók átnézik a jelentkezéseket, és e-mailben vagy telefonon adnak visszajelzést, amint tudnak.",
            "ButtonText_Continue": "Folytatás"
        },
        "LatestJobPostings": {
            "Title": "Legújabb állásajánlatok",
            "Subtitle": "Böngészd a Hubert-partnerek legfrissebb ajánlatait."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Interjúim",
        "MyInterviewsSection_Subtitle": "Válaszd ki az interjút az értékelés és karrierlehetőségek megtekintéséhez.",
        "MyInterviewsSection_ToDo": "Tennivalók"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Összes interjú megtekintése",
        "InterviewNotFound_Title": "Interjú nem elérhető",
        "InterviewNotFound_Description": "Olyan interjú részleteit próbálod megnyitni, amely nincs társítva a fiókodhoz.",
        "ButtonText_GoToAllInterviews": "Ugrás az Interjúimhoz",
        "InterviewDetails": {
            "Title": "Interjú részletei",
            "ForRole": "Pozíció",
            "InterviewCompletedOn": "Interjú befejezve: {{date}} {{time}}"
        },
        "MyResult": {
            "Title": "Eredményem",
            "Subtitle": "Értékelt egyezés",
            "ButtonText_LearnMore": "Nézd meg, hogyan értékeljük a válaszaidat",
            "GotPotential_Title": "Erős potenciál, hiányzik egy követelmény",
            "GotPotential_Description": "Válaszaid erős potenciált mutatnak erre a típusú szerepkörre. Ezen interjú alapján azonban előfordulhat, hogy nem felelsz meg egy vagy több követelménynek ennél a konkrét állásnál. Ez befolyásolhatja a következő lépéseket a toborzó igényeitől és a jelentkezők számától függően. Ha nem jutsz tovább, az nem feltétlenül jelenti azt, hogy nem vagy jó jelölt. Gyakran arról van szó, hogy ehhez a pozícióhoz nagyon konkrét követelmények tartoznak. Nézd meg az alábbi lehetőségeket és tippeket.",
            "GotPotential_DescriptionSecondary": "A Hubert értékelése tájékoztató jellegű. A végső döntést a toborzó hozza meg, és más tényezők, például a jelöltek száma is befolyásolhatják az eredményt.",
            "GreatMatch_Title": "Erős egyezés",
            "GreatMatch_Description": "A válaszaid jól illeszkednek ahhoz, amit a toborzók általában keresnek ebben a szerepben, és megfelelsz a követelményeknek. Szép munka. A toborzó átnézi az összes jelöltet, és dönt a következő lépésekről.",
            "GreatMatch_DescriptionSecondary": "A Hubert értékelése tájékoztató jellegű. A végső döntést a toborzó hozza meg, és más tényezők, például a jelöltek száma is befolyásolhatják az eredményt. Ha nem jutsz tovább, az nem feltétlenül jelenti azt, hogy nem vagy jó jelölt. Gyakran arról van szó, hogy ehhez a pozícióhoz nagyon konkrét követelmények tartoznak. Nézd meg az alábbi lehetőségeket és tippeket.",
            "OkMatch_Title": "Megfelelsz, növeld a hatást",
            "OkMatch_Description": "Megfelelsz az alapkövetelményeknek. Ahhoz, hogy kitűnj, adj több egyértelműséget és konkrétumot a válaszaidhoz. Nézd át a válaszaidat lent, és figyeld meg, hol emelhetné a pontszámodat egy konkrét példa vagy eredmény.",
            "OkMatch_DescriptionSecondary": "A Hubert értékelése tájékoztató jellegű. A végső döntést a toborzó hozza meg, és más tényezők, például a jelöltek száma is befolyásolhatják az eredményt.",
            "NotClearMatch_Title": "Lehet, hogy most nem a megfelelő illeszkedés",
            "NotClearMatch_Description": "Az interjú alapján a válaszaid kevésbé illeszkedhetnek ahhoz, amit a toborzó keres, vagy egy követelmény nem egyértelmű. Ha fejlődni szeretnél, kezdd az alábbi kérdésekkel. Apró finomítások, több konkrétum és világos eredmények sokat javíthatnak az összképen legközelebb.",
            "NotClearMatch_DescriptionSecondary": "A Hubert értékelése tájékoztató jellegű. A végső döntést a toborzó hozza meg, és más tényezők, például a jelöltek száma is befolyásolhatják az eredményt."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Szakmai tapasztalatok, motivációk és kompetenciák",
            "QualifyingRequirements": "Követelmények ennél a konkrét állásnál",
            "NotQualified_Title": "Van tér a fejlődésre",
            "NotQualified_Description": "A válaszaid kevésbé lehettek konkrétak vagy kevésbé fókuszáltak az eredményekre, mint amit a toborzó ennél a szerepnél vár. Nézd meg lent, hol erősít egy konkrét példa, cselekvés vagy világos eredmény.",
            "GreatResults_Title": "Erős válaszok",
            "GreatResults_Description": "A válaszaid alapján jól illeszkedsz ehhez a szereptípushoz, és érthetően fogalmaztál. Ha egy válasz javítható, lent kiemelve látod.",
            "MeetingRequirements_Title": "Követelmények teljesülnek",
            "MeetingRequirements_Description": "A válaszaid azt mutatják, hogy megfelelsz a toborzó által ehhez a pozícióhoz megadott követelményeknek. Jó alap.",
            "NotAllExpectationsMet_Title": "Egy vagy több követelmény hiányzik",
            "NotAllExpectationsMet_Description": "A válaszaid alapján előfordulhat, hogy nem felelsz meg egy vagy több követelménynek, például tanúsítványoknak, engedélyeknek, végzettségi szintnek vagy tapasztalatnak.",
            "ButtonText_FindOutPossibleReasons": "Részletek megtekintése"
        },
        "ScriptFromInterview": {
            "Title": "Teljes interjú szövege",
            "ButtonText_SeeWholeTranscript": "Interjú olvasása",
            "ButtonText_DeleteInterview": "Interjú törlése",
            "Loading_Title": "Betöltés...",
            "Loading_Subtitle": "Várj, amíg betöltjük a leiratot."
        },
        "HowToImproveAtInterviews": {
            "Title": "Hogyan fejlődj az interjúkon",
            "Subtitle_Questions": "Az alábbi kérdésekben javíthatod a válaszaidat.",
            "Subtitle_NoQuestions": "Nem találtunk konkrét javítandó választ. Íme a legjobb módok a hatás növelésére ennél a szerepnél.",
            "GreatMatch_Questions_Description": "Még erős egyezés esetén is lehetnek válaszok, amelyeken erősíteni lehet. Ha találtunk ilyet, lent látod. Kövesd a kérdés előtti utasításokat. Ha egy helyzetről kérdezünk, írd le a helyzetet, mit tettél és mi lett az eredmény. Kerüld a túl rövid válaszokat. Törekedj a világos és konkrét leírásra.",
            "GreatMatch_NoQuestions_Description": "Jól teljesítettél a kérdéseknél. Szép munka.",
            "OkMatch_Questions_Description": "Lent látod azokat a kérdéseket, ahol a válaszod javítható. Kövesd a kérdés előtti utasításokat. Ha egy helyzetről kérdezünk, írd le a helyzetet, mit tettél és mi lett az eredmény. Kerüld a túl rövid válaszokat. Törekedj a világos és konkrét leírásra.",
            "OkMatch_NoQuestions_Description": "A válaszaid szolidak voltak, de ez a szerep versenyképes lehet. Ez azt jelenti, hogy még a jó válaszok is a középmezőnybe kerülhetnek.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Legközelebb fókuszálj a világosságra és a hatásra. Kezdd az eredménnyel, adj egy valós példát, és maradj tömör, általában 3–6 mondat. Légy konkrét arról, mit tettél, hogyan, és mi változott ennek hatására.",
            "GotPotential_Questions_Description": "Még ha erős jelöltnek is tűnsz, néhány válaszon lehet erősíteni. Ha találtunk ilyet, lent látod. Kövesd a kérdés előtti utasításokat. Ha egy helyzetről kérdezünk, írd le a helyzetet, mit tettél és mi lett az eredmény. Kerüld a túl rövid válaszokat. Törekedj a világos és konkrét leírásra.",
            "GotPotential_NoQuestions_Description": "Nem találtunk javítható kérdést a kompetenciák és motivációk terén. Úgy tűnik, jól válaszoltál ezekben a témákban.",
            "NotClearMatch_Questions_Description": "Lent látod azokat a kérdéseket, ahol a válaszod javítható. Kövesd a kérdés előtti utasításokat. Ha egy helyzetről kérdezünk, írd le a helyzetet, mit tettél és mi lett az eredmény. Kerüld a túl rövid válaszokat. Törekedj a világos és konkrét leírásra.",
            "NotClearMatch_NoQuestions_Description": "Nem találtunk egyetlen „rossz” választ sem. Inkább az általános illeszkedésről van szó. Ha a verseny erős, az apró hiányosságok is számíthatnak.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "A következő interjún fókuszálj a konkrétságra. Válassz kérdésenként egy példát, magyarázd el a tetteidet, és oszd meg az eredményt. A rövid és konkrét általában jobb, mint a hosszú és általános.",
            "Alert_WantMoreAdvice": "További tanácsok a Hubert-interjúhoz?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Olvasd el általános tanácsainkat"
        },
        "SimilarOffers": {
            "Title": "Hasonló ajánlatok"
        },
        "HowHubertScoresInterviews": {
            "Title": "Hogyan értékel Hubert?",
            "Description": "Röviden bemutatjuk, hogyan értékeli Hubert a válaszaidat. Hozzáadtunk egy Toborzási folyamat részt is a következő lépésekhez.",
            "Tabs_PossibleOutcomes": "Lehetséges kimenetek",
            "Tabs_RecruitmentProcess": "Toborzási folyamat",
            "AssessedMatch_Title": "Értékelt egyezés",
            "AssessedMatch_Description": "Hubert felméri, mennyire felelnek meg a válaszaid a toborzó elvárásainak. A szerepkör követelményeivel együtt az alábbi eredmények egyikét látod majd.",
            "AssessedMatch_DescriptionSecondary": "A Hubert értékelése tájékoztató jellegű. A végső döntést a toborzó hozza meg, és más tényezők, például a jelöltek száma is befolyásolhatják az eredményt.",
            "GreatMatch_Title": "Erős egyezés",
            "GreatMatch_Description": "Válaszaid jól illeszkednek a pozícióhoz, és a követelményeket is teljesíted. Szép munka. A toborzó átnézi a jelölteket és dönt.",
            "GotPotential_Title": "Erős potenciál, hiányzik egy követelmény",
            "GotPotential_Description": "Válaszaid erős potenciált mutatnak. Azonban ezen interjú alapján lehet, hogy nem felelsz meg egy vagy több követelménynek. Ez befolyásolhatja a következő lépéseket.",
            "OkMatch_Title": "Megfelelsz, növeld a hatást",
            "OkMatch_Description": "Teljesíted a követelményeket. A kitűnéshez a válaszaidnak több világosságra és konkrétságra lehet szükségük. Használd a visszajelzést a példáid erősítésére.",
            "NotClearMatch_Title": "Lehet, hogy most nem a megfelelő illeszkedés",
            "NotClearMatch_Description": "Az interjú alapján a válaszaid kevésbé illeszkedhetnek, és nem biztos, hogy teljesítesz minden követelményt. Nézd át a válaszaidat, hol adhatsz több világosságot és példát.",
            "ProfessionalExperiences_Title": "Szakmai tapasztalatok, motivációk, kompetenciák",
            "ProfessionalExperiences_Description": "Ezek a kérdések a korábbi tapasztalataidról, motivációdról és kompetenciáidról szólnak. A toborzók döntik el a kérdéseket.",
            "GreatResults_Title": "Erős válaszok",
            "GreatResults_Description": "Válaszaid azt mutatják, hogy illeszkedsz a pozícióhoz és világosan kommunikálsz. Ha van javítható válasz, kiemelve látod.",
            "NotQualified_Title": "Van tér a fejlődésre",
            "NotQualified_Description": "Válaszaid kevésbé lehettek konkrétak vagy eredményorientáltak. Keress kiemelt helyeket, ahol egy konkrét példa vagy világos eredmény erősíthet.",
            "QualifyingRequirements_Title": "Alap- vagy kvalifikációs követelmények",
            "QualifyingRequirements_Description": "Ezeket a kérdéseket a toborzó határozta meg követelményként, például bizonyítvány, jogosítvány vagy tapasztalat.",
            "MeetingRequirements_Title": "Követelmények teljesülnek",
            "MeetingRequirements_Description": "Válaszaid alapján teljesíted a követelményeket. Jó alap.",
            "NotAllExpectationsMet_Title": "Egy vagy több követelmény hiányzik",
            "NotAllExpectationsMet_Description": "A válaszaid alapján előfordulhat, hogy nem felelsz meg egy vagy több követelménynek, például tanúsítványoknak, engedélyeknek vagy tapasztalatnak.",
            "RecruitmentProcess_Title": "Toborzási folyamat",
            "RecruitmentProcess_Description": "Hubertot gyakran az első lépésként használják. Lehetővé teszi, hogy mindenki interjúzzon. Mivel a kérdések azonosak, a folyamat következetesebb. Hubert nem használ olyan adatokat, mint életkor vagy nem, csökkentve az elfogultságot.",
            "EventOne_Title": "Hubert interjú",
            "EventOne_Description": "Az interjút akkor és ott végzed, amikor neked megfelel. Nincs időkorlát, bármikor tarthatsz szünetet.",
            "EventTwo_Title": "Interjú értékelése",
            "EventTwo_Description": "Hubert modern technológiával értékeli a válaszaidat. Az eredmények megjelennek a My Hubertben és a toborzónál.",
            "EventThree_Title": "Jelöltek kiválasztása",
            "EventThree_Description": "A toborzók látják az új eredményeket. Áttekintik a válaszaidat és az értékelést. A tájékoztató jellegű értékelés és saját megítélésük alapján döntenek a folytatásról (hívás, teszt, interjú). Ha mások jobban illeszkednek, előfordulhat, hogy nem jutsz tovább a folyamatban.",
            "ButtonText_Close": "Bezárás"
        }
    },
    "MyProfile": {
        "Title": "Profilom",
        "MyDetails": {
            "Title": "Adataim",
            "Label_FirstName": "Keresztnév",
            "Label_LastName": "Vezetéknév",
            "Label_Email": "E-mail",
            "Label_PhoneNumber": "Telefonszám",
            "ButtonText_UpdateDetails": "Adatok frissítése",
            "Error_FirstName_Required": "A keresztnév kötelező.",
            "Error_LastName_Required": "A vezetéknév kötelező.",
            "Error_Email_Required": "Az e-mail kötelező.",
            "Error_Email_Invalid": "Adj meg érvényes e-mail-címet.",
            "Error_PhoneNumber_Invalid": "Érvénytelen telefonszám.",
            "Success_Details_Updated": "Profil frissítve."
        },
        "ChangePassword": {
            "Title": "Jelszó megváltoztatása",
            "Set_Password_Title": "Jelszó létrehozása",
            "Label_CurrentPassword": "Jelenlegi jelszó",
            "Label_NewPassword": "Új jelszó",
            "Label_RepeatNewPassword": "Új jelszó ismét",
            "Alert_SignInAgain": "Jelentkezz be újra a jelszó beállításához.",
            "ButtonText_UpdatePassword": "Jelszó frissítése",
            "ButtonText_SetPassword": "Jelszó beállítása",
            "ButtonText_SignInAgain": "Újra bejelentkezés",
            "Error_CurrentPassword_Required": "A jelenlegi jelszó kötelező.",
            "Error_CurrentPassword_DoesntMatch": "A jelszó nem egyezik a jelenlegi jelszóval.",
            "Error_NewPassword_Required": "Az új jelszó kötelező.",
            "Error_NewPassword_6_Characters": "Az új jelszónak legalább 6 karakteresnek kell lennie.",
            "Error_RepeatNewPassword_Required": "Ismételd meg az új jelszót.",
            "Error_RepeatNewPassword_DoesntMatch": "A jelszavak nem egyeznek.",
            "Success_Password_Changed": "Jelszó frissítve.",
            "Error_Invalid_CurrentPassword": "Érvénytelen jelenlegi jelszó."
        },
        "NotificationPreferences": {
            "Title": "Értesítési beállítások",
            "Label_ReceiveUpdatesToggle": "Szeretnék Hubert-frissítéseket kapni.",
            "Label_ReceiveUpdatesToggleHelpText": "Karrier-útmutatók, interjútippek és egyebek érkeznek."
        },
        "AccountRemoval": {
            "Title": "Fiók törlése",
            "ButtonText_RemoveMyAccount": "Fiók törlése"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Üdv",
        "Subtitle": "Mindjárt elkezded az állásinterjút.",
        "TipBox_Title": "Néhány tipp a sikerhez.",
        "TipBox_Tip1": "Végezd az interjút nyugodt környezetben a koncentráció érdekében.",
        "TipBox_Tip2": "Használj számítógépet billentyűzettel, ha lehetséges.",
        "TipBox_Tip3": "Legyél részletes és konkrét. Hubert és a toborzók meg szeretnének ismerni.",
        "TipBox_Tip4": "Szánj rá időt; nincs időkorlát.",
        "TipBox_Tip5": "Bármikor tarthatsz szünetet, és később folytathatod.",
        "TipBox_Tip6": "Légy önmagad, és állj hozzá úgy, mint egy személyes interjúhoz.",
        "CheckAdviceArticle_Text1": "További tippekért nézd meg ezt a",
        "CheckAdviceArticle_Text2": "cikket",
        "CheckAdviceArticle_Text3": "hasznos tanácsokkal.",
        "ReadyToGetStarted": "Készen állsz?",
        "ORSeparator_Text": "Vagy",
        "ButtonText_StartInterviewNow": "Interjú indítása",
        "ButtonText_SetReminder": "Még nem, emlékeztetőt kérek",
        "PrivacyPolicyText": "Az interjú indításával elfogadod a",
        "PrivacyPolicyLink": "Adatvédelmi irányelveket és a Felhasználási feltételeket"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Szép munka!",
        "CompletedAlert_Subtitle": "Befejezted az interjút.",
        "CompletedAlert_Description": "A toborzók átnézik a jelentkezéseket, és visszajelzést adnak, amint tudnak.",
        "InterviewNotCompleted": "Ez az interjú nincs befejezve."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Súgóközpont",
            "Subtitle": "Válaszok a leggyakoribb kérdésekre Huberről.",
            "Label_Search": "keresés a GYIK-ben",
            "ButtonText_Search": "Keresés"
        },
        "FAQSection": {
            "Tabs_All": "Összes",
            "Tabs_AboutHubertInterview": "Hubert-interjú",
            "Tabs_TechnicalSupport": "Technikai támogatás"
        },
        "StillHaveQuestion": {
            "Title": "További kérdésed van?",
            "Description": "Szívesen segítünk.",
            "DropUsAEmail": "Írj nekünk: hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Lehet telefonhívással lefolytatni az interjút?",
                    "a": "A Hubert jelenleg csak chat formájában működik. Ha egészségügyi okból nem tudod így megcsinálni, keresd a céget."
                },
                {
                    "q": "Részt vehetek az interjún más nyelven?",
                    "a": "Néhány interjúnál választhatsz nyelvet. Ha nem, akkor a nyelv ismerete valószínűleg elvárás. Kérdezd a toborzót."
                },
                {
                    "q": "Büntetést kapok a rövid válaszokért?",
                    "a": "Nem, amíg megfelelően válaszolsz. De a részletek segítenek."
                },
                {
                    "q": "Újra felhasználhatom a válaszaimat egy másik interjúban?",
                    "a": "Igen, ha bejelentkezel a My Hubertbe és hasonló szerepkörre jelentkezel."
                },
                {
                    "q": "Elolvassa egy ember az interjúmat?",
                    "a": "Igen, ügyfeleink manuálisan ellenőrzik az interjúkat."
                },
                {
                    "q": "Mi történik az interjú után?",
                    "a": "Az eredmények a toborzóhoz kerülnek. Ők döntenek a következő lépésről (hívás, teszt, interjú)."
                },
                {
                    "q": "Kivel vegyem fel a kapcsolatot a következő lépések ügyében?",
                    "a": "Lépj kapcsolatba azzal a céggel, ahová jelentkeztél."
                },
                {
                    "q": "Hogyan kerülitek el az elfogultságot?",
                    "a": "Hubert gépként következetes, és nem ismer olyan adatokat, mint a nem vagy életkor, csökkentve az elfogultságot."
                },
                {
                    "q": "Lehet, hogy egy ember interjúztasson a Hubert helyett?",
                    "a": "Keresd a céget ezzel kapcsolatban."
                },
                {
                    "q": "A Hubert emberi lény?",
                    "a": "Nem, Hubert egy számítógépes rendszer."
                },
                {
                    "q": "Utólag módosíthatom a válaszaimat?",
                    "a": "Nem, a benyújtás után nem módosíthatók."
                },
                {
                    "q": "Hogyan lehetek sikeres a Hubert-interjún?",
                    "a": "Olvasd el figyelmesen, kövesd az utasításokat, hozz valós példákat és légy őszinte."
                },
                {
                    "q": "Munkát keresek, kihez forduljak?",
                    "a": "Vedd fel a kapcsolatot a céggel, ahová jelentkeztél."
                },
                {
                    "q": "Nem kaptam visszajelzést az interjú után. Mit tegyek?",
                    "a": "A toborzók döntenek. Ha mások jobban illeszkednek, előfordulhat, hogy nem jutsz tovább a folyamatban. Rákérdezhetsz a toborzónál."
                },
                {
                    "q": "Sok tapasztalatom van, mégsem kaptam meg az állást. Miért?",
                    "a": "Erős lehet a verseny. Kérdezd a céget az okokról, vagy nézd meg a My Hubert visszajelzéseit."
                },
                {
                    "q": "Mennyi ideig tart az interjú?",
                    "a": "Általában 10–25 perc a kérdésektől függően. Ne siess."
                },
                {
                    "q": "Hol olvashatok az adatkezelésetekről?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Miért nem látom a korábbi interjúimat?",
                    "a": "Győződj meg róla, hogy ugyanazt az e-mailt használod a jelentkezésnél és a belépésnél (Google/Facebook esetén is)."
                },
                {
                    "q": "Miért nem kaptam e-mailt az interjúról?",
                    "a": "Nézd meg a spam mappát. Vagy jelentkezz be a My Hubertbe a linkért."
                },
                {
                    "q": "Nem találom az interjú linkjét az e-mailben.",
                    "a": "Nézd meg a spam mappát. Vagy jelentkezz be a My Hubertbe és keresd az 'Interjúim' alatt."
                },
                {
                    "q": "Működik az interjú mobilon?",
                    "a": "Igen! De számítógépen kényelmesebb lehet írni."
                },
                {
                    "q": "Nem működik az interjú, mit tegyek?",
                    "a": "Írj a hubert@hubert.ai címre, és segítünk."
                },
                {
                    "q": "Törölni szeretném a fiókomat, mit tegyek?",
                    "a": "Írj a hubert@hubert.ai címre, és segítünk."
                },
                {
                    "q": "Megszakadt az interjú, hogyan folytathatom?",
                    "a": "Kattints a linkre az e-mailben vagy jelentkezz be a My Hubertbe."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Tanulj Huberttel",
            "Subtitle": "Tudd meg, hogyan növelheted esélyeidet és teljesíthetsz jobban.",
            "Label_Search": "keresés az útmutatókban",
            "ButtonText_Search": "Keresés"
        },
        "TabSelector": {
            "MyFeed": "Saját hírfolyam",
            "InterviewGuides": "Interjú-útmutatók",
            "CareerGuides": "Karrier-útmutatók"
        },
        "NewestOnTheFeed": "Legújabb a hírfolyamban",
        "PickedForMe": "Legfrissebb cikkek",
        "InterviewGuides": "Interjú-útmutatók",
        "CareerGuides": "Karrier-útmutatók"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Vissza az összes cikkhez"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Jelszó visszaállítása",
        "ResetLinkAlert_Subtitle": "Kattints az e-mailben kapott linkre új jelszó beállításához.",
        "PasswordNotSetAlert_Message": "Nincs jelszó, jelentkezz be ezzel:",
        "ResetYourPassword": {
            "MainTitle": "Nézd meg a Hubert-interjúd eredményeit",
            "Subtitle": "Jelentkezz be, hogy lásd az eredményeket, kapj visszajelzést, olvass tanácsokat és még sok mást.",
            "FormSectionTitle": "Jelszó visszaállítása",
            "Label_NewPassword": "Új jelszó",
            "Label_ConfirmNewPassword": "Új jelszó megerősítése",
            "Error_NewPassword_Required": "Kérjük, add meg az új jelszót.",
            "Error_Password_6_Characters": "Az új jelszónak legalább 6 karakter hosszúnak kell lennie.",
            "Error_ConfirmNewPassword_Required": "Meg kell erősítened az új jelszót.",
            "Error_ConfirmNewPassword_NotMatch": "A jelszavak nem egyeznek.",
            "Error_MalformedResetUrl": "Érvénytelen biztonsági kód. Próbáld újra.",
            "Error_ResetPasswordFailed": "Hiba történt a visszaállításkor. Próbáld újra.",
            "Error_WeakPassword": "A jelszónak legalább 6 karakterből kell állnia.",
            "Error_InvalidCode_Title": "A kérelem lejárt vagy érvénytelen.",
            "Error_InvalidCode_Subtitle": "Próbáld meg újra visszaállítani a jelszavad.",
            "ButtonText_SetNewPassword": "Új jelszó és bejelentkezés",
            "ButtonText_RememberYourPassword": "Emlékszel a jelszóra?",
            "ButtonText_SignInInstead": "Bejelentkezés"
        }
    },
    "PageNotFound": {
        "Title": "Az oldal nem található",
        "Description": "Nem találjuk a keresett oldalt.",
        "ButtonText_GoToDashboard": "Ugrás a Vezérlőpultra",
        "ButtonText_GoToLogin": "Ugrás a Bejelentkezéshez"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "A válaszok újrafelhasználása ennél az interjúnál még nem elérhető. Várhatóan hamarosan az lesz, de addig is elvégezheted az interjút.",
        "DescriptionLine2": "Kattints az alábbi gombra a folytatáshoz.",
        "ButtonText_TakeMeToTheInterview": "Ugrás az interjúra"
    },
    "UnsubscribeFromEmails": {
        "Title": "Biztos vagy benne?",
        "Subtitle": "Nem kapsz több e-mailt erről az állásról:",
        "SelectTheReason": "Válassz okot.",
        "ReasonText1": "Másik állást találtam.",
        "ReasonText2": "Már nem érdekel ez az állás.",
        "ReasonText3": "Egyéb",
        "ButtonText_Unsubscribe": "Leiratkozás",
        "Placeholder_YourReason": "Az okaid",
        "Success_Title": "Sikeresen leiratkoztál.",
        "Loading": "Betöltés...",
        "Error_YourReason_Required": "Kérjük, add meg az okot.",
        "Error_ServerIssue": "Hiba történt a leiratkozás során."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Próbáld újra"
    },
    "Outreach": {
        "CandidateNotFound": "A jelölt nem található",
        "CandidateNotFoundDesc": "Nem találtuk a keresett interjú részleteit.",
        "InterviewEnded": "Az interjú befejeződött",
        "InterviewEndedDesc1": "Ez az interjú már véget ért, vagy már nem érhető el.",
        "InterviewEndedDesc2": "Köszönjük a ránk szánt idejét. Ha kérdése van, forduljon a toborzó csapathoz.",
        "ReadyTitle": "Készen áll az interjúra, {{firstName}}?",
        "InvitationDesc": "A Hubert a(z) {{companyName}} nevében egy kb. 1-2 perces chat-alapú interjúra invitálja Önt.",
        "Button_StartChat": "Chat-interjú indítása",
        "CancelNotice": "Az itt történő indítás törli az erre a munkakörre ütemezett hívást.",
        "PreferNotToContinue": "Inkább nem folytatná?",
        "DeclineLabel": "Nem érdekel ez a munkakör. Kérem, ne keressenek többet ezzel a pozícióval kapcsolatban.",
        "Button_ConfirmAndDecline": "Megerősítés és elutasítás",
        "Processing": "Feldolgozás...",
        "Toast_DeclineSuccess": "Interjú sikeresen elutasítva",
        "Toast_CancelVoiceInfo": "Hangalapú interjú törölve. A funkció hamarosan elérhető lesz.",
        "Toast_CancelError": "Nem sikerült az interjú törlése. Kérjük, próbálja újra.",
        "Footer_WithdrawConsent": "Hozzájárulását bármikor visszavonhatja. Tudjon meg többet a(z) ",
        "Footer_PrivacyPolicySuffix": " adatvédelmi szabályzatában",
        "Footer_And": " és a ",
        "Footer_HubertPrivacyLink": "Hubert adatvédelmi szabályzatában és Általános Szerződési Feltételeiben",
        "Chat_InterviewWith": "Interjú a(z) {{companyName}} vállalattal",
        "Chat_StatusConnected": "Kapcsolódva",
        "Chat_StatusError": "Hiba",
        "Chat_StatusDisconnected": "Szétkapcsolva",
        "Chat_StatusConnecting": "Kapcsolódás...",
        "Chat_ReadyToStart": "Készen áll az interjú indítására?",
        "Chat_ButtonStart": "Interjú indítása",
        "Chat_SayHello": "Köszönjön a beszélgetés elindításához.",
        "Chat_EmptyState": "Küldjön egy üzenetet az interjú elindításához.",
        "Chat_SelectLanguage": "Válassz nyelvet",
        "Chat_Placeholder": "Írja meg üzenetét...",
        "Chat_ButtonSend": "Küldés",
        "Chat_ButtonBack": "Vissza",
        "LoadingCandidateDetails": "Jelölt adatainak betöltése...",
        "FetchingCandidateDetails": "Jelölt adatainak lekérése...",
        "Chat_StatusReady": "Kapcsolatra vár...",
        "Chat_ForbiddenError": "Ez a chat-interjú már nem érhető el.",
        "Chat_GeneralError": "Nem sikerült elindítani a chatet. Kérjük, próbálja meg később.",
        "Chat_SelectUiLanguage": "A menü nyelve",
        "Chat_InterviewTitle": "Állásinterjú"
    }
}
